var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileReservation = function SvgProfileReservation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.555 5.237v2.011c0 1.14.937 2.067 2.09 2.067 1.152 0 2.09-.927 2.09-2.067V5.242c1.948.05 3.515 1.48 3.515 3.237v14.194c0 1.972-1.623 3.577-3.617 3.577H8.617C6.623 26.25 5 24.645 5 22.673V8.478c0-1.735 1.532-3.153 3.447-3.232v2.002c0 1.14.938 2.067 2.09 2.067 1.153 0 2.09-.927 2.09-2.067v-2.01h5.928Zm4.98 6.642H7.715v9.667c0 1.114.916 2.02 2.043 2.02h11.734c1.127 0 2.043-.906 2.043-2.02v-9.667ZM10.538 3.75c.502 0 .91.403.91.9v2.598c0 .497-.408.9-.91.9a.905.905 0 0 1-.91-.9V4.65c0-.497.407-.9.91-.9Zm10.107 0c.503 0 .91.403.91.9v2.598c0 .497-.407.9-.91.9a.905.905 0 0 1-.91-.9V4.65c0-.497.407-.9.91-.9Z",
    fill: "#4BABC9"
  })));
};
export default SvgProfileReservation;